import React from 'react';
import ColorCrafterLegalDocumentPage from './ColorCrafterLegalDocumentPage';

const TermsOfServicePage: React.FC = () => <ColorCrafterLegalDocumentPage kind="terms" />;

export default TermsOfServicePage;
